import { initializeApp } from 'firebase/app';
import {
  connectFirestoreEmulator,
  getFirestore,
  Timestamp,
} from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAMFD2ptT5YojZUmJcqsfvrWxOVyFvdgSQ',
  authDomain: 'fspl-online.firebaseapp.com',
  projectId: 'fspl-online',
  storageBucket: 'fspl-online.appspot.com',
  messagingSenderId: '711804836187',
  appId: '1:711804836187:web:86950dbf1445b6d83da27e',
};

const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const cloudFucntions = getFunctions(app);
export const storage = getStorage(app);

export const dateToFirestoreTimestamp = (date) => {
  const _date = new Date(date);

  return Timestamp.fromDate(_date);
};

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const firebaseTimestampToDate = (timestamp) => {
  const date = timestamp.toDate();
  return `${date.getDate()} ${months[date.getMonth()]}, ${date.getFullYear()}`;
};

export const uploadFileToCloud = async (file) => {
  try {
    const fileRef = ref(storage, file.name);

    const snapshot = await uploadBytes(fileRef, file);
    const url = await getDownloadURL(snapshot.ref);
    return url;
  } catch (error) {
    console.log(error);
  }
};

// if (process.env.NODE_ENV === 'development') {
//   connectFirestoreEmulator(firestore, 'localhost', 8080);
//   connectFunctionsEmulator(cloudFucntions, 'localhost', 5001);
// }
